const hexToRgbA = (hex, opacity) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = `0x${c.join('')}`;
    return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(
      ',',
    )},${opacity})`;
  }
  return '';
};

const rgbToHex = rgb => {
  rgb = rgb.match(
    /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i,
  );
  return rgb && rgb.length === 4
    ? `#${('0' + parseInt(rgb[1], 10).toString(16)).slice(-2)}${(
        '0' + parseInt(rgb[2], 10).toString(16)
      ).slice(-2)}${('0' + parseInt(rgb[3], 10).toString(16)).slice(-2)}`
    : '';
};

export default {
  getRgbA(color, opacity = 1) {
    if (color.indexOf('#') === 0) {
      return hexToRgbA(color, opacity);
    }
    if (color.indexOf('rgb') === 0 && color.indexOf('a') !== 3) {
      return color.replace(')', `, ${opacity})`).replace('rgb', 'rgba');
    }
    if (color.indexOf('rgba') === 0) {
      return color.replace(/[\d\.]+\)$/g, `${opacity})`);
    }
    return '';
  },

  getFileSize(fileSizeInBytes) {
    const e = (Math.log(fileSizeInBytes) / Math.log(1024)) | 0;
    return `${(fileSizeInBytes / Math.pow(1024, e)).toFixed(
      e ? 2 : 0,
    )} ${'KMGTPEZY'[e - 1] || ''}B`;
  },

  isWhite(color) {
    let hexColor = color;
    if (color.indexOf('#') !== 0) {
      hexColor = rgbToHex(color);
    }
    return hexColor.toUpperCase() === '#FFFFFF';
  },

  diffMinutes(prev, after) {
    const diffMs = after - prev;
    return Math.floor(diffMs / 60000);
  },

  getCurrentTimestamp() {
    return new Date().getTime();
  },

  getCurrentDate() {
    return new Date();
  },
};
